export const supplierContactRoutes = [
  {
    path: ':id',
    name: 'supplier-contact-details',
    component: () =>
      import(/* webpackChunkName: "supplier-contact-details" */ './SupplierContactDetails.vue')
  }
];
